module.exports = __webpack_public_path__ + "static/media/13.Ice Crusher Machine.81b5485c.jpg";